<template>
	<span class='DealComponent'>{{notification.context.deal.name}}</span>
</template>

<script>
export default {
	name:  'DealComponent',
	props: {
		notification: {
			type: Object
		}
	}
};
</script>
